/** Public listing fallback when event body copy is missing. */
export const EVENT_DESCRIPTION_PLACEHOLDER = 'Description coming soon';

export function isEventDescriptionPlaceholder(text: string | null | undefined): boolean {
  if (!text?.trim()) {
    return true;
  }
  return text.trim().toLowerCase() === EVENT_DESCRIPTION_PLACEHOLDER.toLowerCase();
}
